module.exports = __webpack_public_path__ + "img/sqr.c29b4e16.jpg";